/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

interface Props {
  title?: string;
  children: React.ReactNode | React.ReactNode[];
}

export function SidePanelSection({ title, children }: Props) {
  return (
    <StyledSection>
      {title && <StyledSectionTitle>{title}</StyledSectionTitle>}
      {children}
    </StyledSection>
  );
}

const StyledSectionTitle = styled.h1`
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
  user-select: none;
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
